import styles from "./ShareSlidePopup.module.scss";
import classNames from "classnames";
import useShareTopic from "../../hooks/shareTopicHooks/useShareTopic";
import useToast from "../../hooks/useToast";

const ShareSlidePopup = () => {
  const shareContext = useShareTopic();
  const toast = useToast();
  const copyIcon = classNames("tg-icons-Copy", "size-20");
  const shareIcon = classNames("tg-icons-Share", "size-20");
  const crossIcon = classNames("size-25", "medium", "tg-icons-Cross");

  const triggerToast = () => {
    toast.triggerToast({
      type: "info",
      primaryMessage: "Copied!",
      autoHideDuration: 3000,
    });
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => triggerToast())
      .catch((err) => console.error("Failed to copy URL:", err));
  };

  const showShareFeature = () => {
    return navigator.share;
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: window.location.href,
        });
      } catch (err) {
        console.warn("Share failed:", err);
      }
    } else {
      handleCopy();
    }
  };

  return (
    <div className={styles.popup} aria-label="Share Topic Modal">
      <div className={styles.headingRow}>
        <button className={styles.popupClose} onClick={shareContext.closeModal}>
          <i className={crossIcon}></i>
        </button>
      </div>
      <div className={classNames("size-14 medium", styles.linkRow)}>
        <button
          type="button"
          className={styles.button}
          onClick={handleCopy}
          aria-label="Copy to clipboard"
        >
          <div>Copy link</div>
          <i className={copyIcon} />
        </button>
      </div>
      {showShareFeature() && (
        <div className={classNames("size-14 medium", styles.linkRow)}>
          <button
            type="button"
            className={styles.button}
            onClick={handleShare}
            aria-label="Share link with"
          >
            <div>Share</div>
            <i className={shareIcon} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareSlidePopup;
